const bxfPhone = {
    svg: '<svg style="width:1rem; height:1rem;" viewBox="0 0 16 16"><path d="M1 1.875 4.938 1l2.187 3.938L4.834 6.77a10.552 10.552 0 0 0 4.396 4.396l1.832-2.291L15 11.063 14.125 15h-.875C6.485 15 1 9.515 1 2.75z"/></svg>',
};

export { bxfPhone as default };
